export const customerPasswordRegExp = /(?=.*\d)(?=.*[A-Za-z])(?=.*[!#$%&*?@^_-])(?!.*\s).{6,}/;
export const invalidPasswordMsg = 'Minimum length of this field must be equal or greater than 6 symbols. Leading and trailing spaces will be ignored.';
